import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_PsEmergencyAllergyInformation = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_PsEmergencyAllergyInformation' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Person Served Emergency/Allergy Information</h3></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServedName' name='txtPersonServedName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtRecord' name='txtRecord' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Home Phone</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtHomePhone' name='txtHomePhone' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>SS#:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>DOB</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txt_S' name='txt_S' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>
                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Primary Insurance Provider</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Secondary Insurance Provider</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrimaryInsuranceProvider' name='txtPrimaryInsuranceProvider' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtSecondaryInsuranceProvider' name='txtSecondaryInsuranceProvider' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Emergency Name & Phone </span>
                    1.<input type='text' id='txtEmergencyName_1' name='txtEmergencyName_1' className='add-only w-700 custom-add-only' /><br />
                    2.<input type='text' id='txtEmergencyName_2' name='txtEmergencyName_2' className='add-only w-700 custom-add-only' /><br />
                    3.<input type='text' id='txtEmergencyName_3' name='txtEmergencyName_3' className='add-only w-700 custom-add-only' /><br />
                    4.<input type='text' id='txtEmergencyName_4' name='txtEmergencyName_4' className='add-only w-700 custom-add-only' />
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Physician(s):</span>
                    <textarea id='txtPhysician' name='txtPhysician' className='add-only'></textarea>
                </p>
                
                <p className='w-750'>
                    <span className='eleHeader'>Medication(s):</span>
                    <textarea id='txtMedication' name='txtMedication' className='add-only'></textarea>
                </p>
                
                <p className='w-750'>
                    <span className='eleHeader'>Other needed Medical Information(s):</span>
                    <textarea id='txtOtherNeededMedical' name='txtOtherNeededMedical' className='add-only'></textarea>
                </p>
                
                <p className='w-750'>
                    <span className='eleHeader'>Drug Allergies:</span>
                    <textarea id='txtDrugAllergies' name='txtDrugAllergies' className='add-only'></textarea>
                </p>
                
                <p className='w-750'>
                    <span className='eleHeader'>Other Allergies:</span>
                    <textarea id='txtOtherAllergies' name='txtOtherAllergies' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <h3>Other Entities:</h3>
                    </p>
<table>
<tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Probation Officer Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Office: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProbationOfficerName' name='txtProbationOfficerName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOffice' name='txtOffice' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone Number:</span></td>
                        <td className='w-200'>
                            <span className='eleHeader'>Fax Number:</span></td>
                            <td className='w-350'>
                            <span className='eleHeader'>Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtFaxNumber' name='txtFaxNumber' className='add-only' /></td>
                            <td className='w-350'>
                            <input type='text' id='txtEmail' name='txtEmail' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DFCS Caseworker Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Office: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDfcsCaseworkerName' name='txtDfcsCaseworkerName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOffice_1' name='txtOffice_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>Phone Number:</span></td>
                        <td className='w-200'>
                            <span className='eleHeader'>Fax Number:</span></td>
                            <td className='w-350'>
                            <span className='eleHeader'>Email:</span></td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id='txtPhoneNumber_1' name='txtPhoneNumber_1' className='add-only' /></td>
                        <td className='w-200'>
                            <input type='text' id='txtFaxNumber_1' name='txtFaxNumber_1' className='add-only' /></td>
                            <td className='w-350'>
                            <input type='text' id='txtEmail_1' name='txtEmail_1' className='add-only' /></td>
                    </tr>
</table>

            </div>
        </form>

    )
}  
